// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f4818e6d","872":"9ea5b43e"}[chunkId] + ".chunk.js";
};